<template>
	<div class="sidebar-wrapper" :class="{ 'collapsed': isCollapse }">
		<div class="logo-section">
			<el-image style="height: 37px" :src="url" fit="contain" v-show="!isCollapse"></el-image>
			<el-image style="height: 26px" :src="urlS" fit="contain" v-show="isCollapse"></el-image>
		</div>

		<el-menu :default-active="activeMenu" class="el-menu-vertical" :collapse="isCollapse" background-color="#ffffff"
			text-color="#303133" active-text-color="#2e4fed" router unique-opened>
			<template v-for="route in menuList">
				<el-submenu v-if="route.children && route.children.length > 0" :key="route.path" :index="route.path">
					<template slot="title">
						<i :class="route.meta.icon || 'el-icon-folder'"></i>
						<span>{{ $t(route.meta.title) }}</span>
					</template>

					<el-menu-item v-for="child in route.children" :key="child.path"
						:index="resolvePath(route.path, child.path)">
						<span slot="title">{{ $t(child.meta.title) }}</span>
					</el-menu-item>
				</el-submenu>

				<el-menu-item v-else :key="route.name" :index="resolvePath('', route.path)">
					<i :class="route.meta.icon || 'el-icon-folder'"></i>
					<span v-if="route.path != 'chat'" slot="title">{{ $t(route.meta.title) }}</span>
					<span v-else slot="title">{{ $t(route.meta.title) }}</span>
					<el-badge v-if="route.path === 'chat' && unread_num > 0" :value="unread_num"
						class="chat-badge" type="danger" />
				</el-menu-item>
			</template>
		</el-menu>
	</div>
</template>

<script>
	import routesConfig from '@/router/pc.js';
	import {
		mapState
	} from 'vuex';

	export default {
		name: 'Sidebar',
		data() {
			return {
				url: require('../assets/image/1.png'),
				urlS: require('../assets/image/logos.png'),
				isCollapse: false,
				menuList: routesConfig.find(r => r.name === 'pc').children.filter(item => {
					return item.meta && !item.meta.hidden;
				}),
				unread_num: 0
			};
		},
		computed: {
			...mapState('kefu', ['message_unread_num']),
			activeMenu() {
				return this.$route.path;
			}
		},
		watch: {
			//有无更多列表
			message_unread_num: {
				handler(val) {
					this.unread_num = val
				},
				immediate: true
			},
		},
		created() {
			this.$root.$on('togglesidebar', (status) => {
				this.isCollapse = status;
			});
		},
		beforeDestroy() {
			this.$root.$off('togglesidebar');
		},
		methods: {
			resolvePath(parentPath, childPath) {
				const base = '/home';
				if (parentPath && parentPath !== '') {
					return `${base}/${parentPath}/${childPath}`.replace(/\/+/g, '/');
				}
				return `${base}/${childPath}`.replace(/\/+/g, '/');
			},

		}
	};
</script>

<style lang="scss" scoped>
	.sidebar-wrapper {
		height: 100vh;
		display: flex;
		flex-direction: column;
		background-color: #fff; // 整体背景白底
		overflow: hidden;

		&.collapsed {
			width: 64px;
		}

		.logo-section {
			height: 60px;
			display: flex;
			align-items: center;
			justify-content: center;
			padding: 0 15px;
		}

		.el-menu-vertical {
			flex: 1;
			border-right: none;
			overflow-y: auto;
			overflow-x: hidden;

			&::-webkit-scrollbar {
				display: none;
			}

			scrollbar-width: none;

			&:not(.el-menu--collapse) {
				width: 200px;
			}

			// --- 选中状态的淡蓝色背景 ---
			::v-deep .el-menu-item.is-active {
				background-color: #d5ddfb !important; // 淡蓝色背景
			}

			// 鼠标悬停时的背景色
			::v-deep .el-menu-item:hover,
			::v-deep .el-submenu__title:hover {
				background-color: #f5f7fa !important;
			}
		}
	}

	// 兼容折叠状态
	::v-deep .el-menu--collapse {
		width: 64px;

		.el-submenu__title span,
		.el-submenu__icon-arrow {
			display: none;
		}
	}
	
	::v-deep .el-badge__content{
		border: unset;
	}

	.chat-badge {
		position: absolute;
		right: 10px;
		top: 50%;
		transform: translateY(-50%);
	}
</style>